import React, { Fragment, useState, useEffect } from 'react';
import axios from "axios";
import Modal from '../../common/Modal';
import Button from '../../Button';
import Spinner from "../../Spinner";
import MultiSelect from '../../common/Forms/MultiSelect';
import styles from "../TeacherList/TeacherModal.module.sass";

const TeacherAids = ({ schoolId, educatorId, fromAdmin }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [existingTeachers, setExistingTeachers] = useState([]);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    axios
      .get(`/api/v1/students/teacher_aids?school_id=${schoolId}&educator_id=${educatorId}`)
      .then((data) => {
        console.log(data.data.existing_aids)
        setTeachers(data.data.teachers)
        setExistingTeachers(data.data.existing_aids)
      })
  }, [schoolId, educatorId])

  const handleSubmit = (e) => {
    e.preventDefault();

    $.ajax({
      url: `/schools/${schoolId}/add_teacher_aids.js`,
      data: { school_id: schoolId, educator_id: educatorId, student_ids: selectedStudentIds.join(','), from_admin: fromAdmin },
      type: 'POST',
      dataType: 'script',
    }).then(() => {
      $('#students_list').html('');
      $.get(`/admin/schools/${schoolId}/composites.js?teacher_id=${educatorId}`, {});
      closeModal();

      setExistingTeachers(teachers.filter((option) => selectedStudentIds.includes(option.value)))
    })
  }

  const handleChange = (options) => {
    const ids = options.map((option) => option.value);

    setSelectedStudentIds(ids);
  }

  const modalContent = () => {
    return (
      <div className={styles.modalBody}>
        <MultiSelect
          options={teachers}
          selectedValues={existingTeachers}
          handleChange={handleChange}
          placeholderText="Select aides"
        />

        <br />

        <button className="btn btn-primary" onClick={handleSubmit}>Add aides to classroom</button>
      </div>
    )
  }

  return (
    <Fragment>
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel='Teacher Aides'
        headerText='Teacher Aides'
      >
        {!teachers && <Spinner color="blue" />}
        {teachers && modalContent()}
      </Modal>

      <div className={styles.buttonContainer}>
        <Button onClick={openModal}>View/Add Teacher Aides</Button>
      </div>
    </Fragment>
  )
}

export default TeacherAids;
